import React from 'react';

import PropTypes from 'prop-types';
import querystring from 'query-string';
import { connect } from 'react-redux';

import { Redirect } from 'wanderu-component-react-router-link';
import {
    PageDialogWrapper,
} from 'wanderu-components';
import {
    logInAction,
    resetPasswordAction,
    userInfoSelectors,
} from 'wanderu-ducks-account';
import {
    localize,
} from 'wanderu-i18n';

import ResetPassword from '../../components/ResetPassword/ResetPassword';
import baseAppConfig from '../../config/baseApp.locales';

import styles from './ResetPassword.scss';

function ResetPasswordContainer(props) {
    const {
        error,
        loading,
        location,
        facebookLogIn,
        googleButtonLogIn,
        isLoggedIn,
        resetPassword,
        reset,
        success,
        t,
    } = props;

    if (isLoggedIn) {
        return (
            <Redirect
                href="/account/mytrips/"
                push
            />
        );
    }

    const { email } = querystring.parse(location.search);

    return (
        <div className={styles.container}>
            <PageDialogWrapper
                title={t('reset-password-form-title')}
            >
                <ResetPassword
                    email={email}
                    error={error}
                    loading={loading}
                    onFacebookClick={facebookLogIn}
                    onGoogleClick={googleButtonLogIn}
                    onResetPassword={resetPassword}
                    reset={reset}
                    success={success}
                />
            </PageDialogWrapper>
        </div>
    );
}

ResetPasswordContainer.propTypes = {
    error: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    facebookLogIn: PropTypes.func.isRequired,
    googleButtonLogIn: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    resetPassword: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    success: PropTypes.bool.isRequired,
    t: PropTypes.func,
};

ResetPasswordContainer.defaultProps = {
    loading: false,
    success: false,
    facebookLogIn() {},
    googleButtonLogIn() {},
    resetPassword() {},
    reset() {},
};

const mapDispatchToProps = {
    facebookLogIn: logInAction.facebookLogIn,
    googleButtonLogIn: logInAction.googleButtonLogIn,
    resetPassword: resetPasswordAction.resetPassword,
    reset: resetPasswordAction.reset,
};

const mapStateToProps = (appState) => {
    return {
        isLoggedIn: userInfoSelectors.selectUserLoggedIn(appState),
        loading: resetPasswordAction.selectWorking(appState),
        error: resetPasswordAction.selectError(appState),
        success: resetPasswordAction.selectSuccess(appState),
    };
};

export {
    ResetPasswordContainer,
    mapStateToProps,
};

const localizedResetPasswordContainer = localize(ResetPasswordContainer, ['t'], baseAppConfig.namespace);
export default connect(mapStateToProps, mapDispatchToProps)(localizedResetPasswordContainer);
